var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"market-tabs"},_vm._l((Object.entries(_vm.tabs)),function([key, name]){return _c('div',{staticClass:"tab",class:{ active: key === _vm.value },on:{"click":function($event){return _vm.$emit('change', key)}}},[_vm._v(_vm._s(name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }